module.exports = __webpack_public_path__ + "img/info-filled.af82a47b.svg";